import React from 'react';
import IngredientsApp from './Functionality/IngredientsApp';
import {VIEW_TYPE} from '../../../../enums/ViewType';
import IngredientsCards from './SubComponents/IngredientsCards';
import DeleteModal from '../../../Modals/DeleteModal';
import IngredientsTable from "./IngredientsTable";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack
 * @Email : kpozos@ibl.mx
 *
 */
const Ingredients = ({ setBodyForExport, modified, setModified, option}) => {

    const {
        t,
        view,
        setView,
        isAllChecked,
        setIsAllChecked,
        deleteModalShow,
        selectedList,
        setSelectedList,
        handleDeleteSelected,
        handleDeleteModalClose,
        handleDelete
    } = IngredientsApp({
        setModified
    });

    return (
        <>
            {view === VIEW_TYPE.GRID.name &&
            <>
                <IngredientsCards
                    view={view}
                    setView={setView}
                    setBodyForExport={setBodyForExport}
                    modified={modified}
                    setModified={setModified}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    option={option}
                />
            </>
            }

            {view === VIEW_TYPE.LIST.name &&
            <>
                <IngredientsTable
                    view={view}
                    setView={setView}
                    setBodyForExport={setBodyForExport}
                    modified={modified}
                    setModified={setModified}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    handleDelete={handleDelete}
                    option={option}
                />
            </>
            }

            { deleteModalShow &&
                <DeleteModal
                    show={deleteModalShow}
                    onHide={() => handleDeleteModalClose()}
                    onClickFn={() => {
                        handleDeleteSelected()
                    }}
                    data={selectedList}
                    isReset={setSelectedList}
                    isAllReset={setIsAllChecked}
                    title_modal={t('delete_ingredients')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('ingredients')}
                    buttonCancelText={'cancel'}
                />
            }

        </>
    );
}

export default Ingredients;
